<template>
  <b-card class="w-100 d-flex my-border" :title="$t('Employee QR')">
    <b-row>
      <b-col cols="6">
        <b-img :src="imgQr" class="my-qr"></b-img> 
      </b-col>
      <b-col cols="6">
        <div class="info-container">
          <div>
            <div>{{ fullName }}</div>
            <b-badge variant="light-warning" class="mt-1">{{ documentNumber }}</b-badge>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import UserService from "@/views/users/services/users.service.js";
export default {
  props: {
    userId: {
      type: Number,
      requred: true,
    },
  },
  data() {
    return {
      imgQr: null,
      documentNumber: null,
      fullName: null,
    };
  },
  methods: {
    async getQr() {
      const { data } = await UserService.getUserQr({ user_id: this.userId });
      this.imgQr = "data:image/png;base64," + data.qrCode;
      this.documentNumber = data.document;
      this.fullName = data.user;
    },
  },

  mounted() {
    this.getQr();
  },
};
</script>

<style scoped>
.my-qr {
  width: 100%;
  padding: 10px;
  background-color: #FFFFFF;
}

.info-container {
  height: 100%;
  display: flex;
  align-items: center;
}
</style>